import * as types from '../mutation_types';

export default {
  [types.SET_WORKSTATION](state, value) {
    state.workstation = value;
  }
}
